export const NS_GET_SUPERVISOR_DASHBOARD_DATA =
  'NS_GET_SUPERVISOR_DASHBOARD_DATA';
export const NS_GET_SUPERVISOR_DASHBOARD_DATA_SUCCESS =
  'NS_GET_SUPERVISOR_DASHBOARD_DATA_SUCCESS';
export const NS_GET_SUPERVISOR_DASHBOARD_DATA_FAIL =
  'NS_GET_SUPERVISOR_DASHBOARD_DATA_FAIL';

export function getSupervisorDashboardData(payload) {
  return {
    type: NS_GET_SUPERVISOR_DASHBOARD_DATA,
    payload
  };
}

export function getSupervisorDashboardDataSuccess(payload) {
  return {
    type: NS_GET_SUPERVISOR_DASHBOARD_DATA_SUCCESS,
    payload
  };
}
